import {baseDev, baseProd} from './baseUrl';


const baseUrl = process.env.NODE_ENV==="development" ? baseDev:baseProd;


function JSON_stringify(params) {
    let FD = new FormData();
    for (let key in params) {
        FD.append(key, params[key]);
    }
    return FD;
}

export async function request(url, method, params, json) {
    let config = {
        credentials: 'include',
        method: method,
    };
    if (method == 'post') {
        config.body = json ? JSON.stringify(params) : JSON_stringify(params);
    }
    if (json) {
        config.headers = {
            'content-type': "application/json",
        };
    }
    return fetch(baseUrl + url, config).then(res => res.json())
}

export async function get(url) {
    return request(url, "get");
}

export async function post(url, params, json) {
    let new_params = params;
    new_params.token = sessionStorage.getItem("token");
    new_params.i_uid = sessionStorage.getItem("userid");
    // new_params.token = "8000001170985060";
    // new_params.i_uid = "3247";
    new_params.app = "masterdata";
    new_params.version = "1.0";
    new_params.i_mid=sessionStorage.getItem('mids');
    return request(url, "post", new_params, json);
}

//login
export async function dologin(url, params, json) {
    let new_params = params;
    new_params.app = "masterdata";
    new_params.version = "1.0";
    return request(url, "post", new_params, json);
}